import React, { useCallback } from 'react'
import DebouncedInput from '../../../../molecules/DebouncedInput'
import { useSyncedTransactions } from './SyncedTransactionsProvider'

const inputStyle = {
  minWidth: '360px',
  maxWidth: '540px'
}

export default function SyncedTransactionsTextSearch () {
  const { onSearchChange } = useSyncedTransactions()

  const handleChange = useCallback((value) => {
    onSearchChange(value ?? '')
  }, [onSearchChange])

  return (
    <DebouncedInput
      placeholder='Search ticker, product, account number, notes...'
      delay={350}
      onChange={handleChange}
      style={inputStyle}
    />
  )
}
